import { render, staticRenderFns } from "./PreviewFileFreeMode.vue?vue&type=template&id=6e036b5e&scoped=true&"
import script from "./PreviewFileFreeMode.vue?vue&type=script&lang=js&"
export * from "./PreviewFileFreeMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e036b5e",
  null
  
)

export default component.exports